/** @format */

import { forwardRef, useEffect, type HTMLAttributes, type ReactNode } from 'react';

const DEFAULT_DOCUMENT_TITLE = 'ATE | VDO Portal';

interface PageProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  title?: string;
}

const Page = forwardRef<HTMLDivElement, PageProps>(({ children, title = '', ...rest }, ref) => {
  useEffect(() => {
    const nextTitle = title ? `${DEFAULT_DOCUMENT_TITLE} - ${title}` : DEFAULT_DOCUMENT_TITLE;
    document.title = nextTitle;

    return () => {
      document.title = DEFAULT_DOCUMENT_TITLE;
    };
  }, [title]);

  return (
    <div ref={ref} {...rest}>
      {children}
    </div>
  );
});

export default Page;
